import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
const BASEURL = environment.apiBase;
@Injectable({
  providedIn: 'root'
})
export class FunnelService {

  constructor(private http: HttpClient) { }


  public postPotentialCoach(data:PotentialCoach): Observable<any>{
    return this.http.post(`${BASEURL}/coaches/request`, {coaches_request:data}, {
      responseType:'json'
    })
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}
